export function getApiBaseUrl() {
  const apiBase = import.meta.env.VITE_API_BASE_URL;
  return apiBase ?? '';
}
